// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__2rJDl","title":"AfterImages90_title__1Mw-_","images":"AfterImages90_images__3EmSC"};